import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import React from 'react';
import { ArrowDrop } from './ModalArrowDrop';

const ModalHeadingRow = ({ styles, orderBy, order, state, setState }) => {
  const sortData = (type) => {
    setState({ orderBy: type });
    const { orderBy, order } = state;
    const isAsc = orderBy === type && order === 'asc';
    setState({ order: isAsc ? 'desc' : 'asc' });
  };
  return (
    <TableHead>
      <TableRow style={styles.tableRow}>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '50px',
          }}
          className="sticky"
          align="left"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 1 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white', width: '60px' }}
            active={orderBy === 'expiry'}
            direction={orderBy === 'expiry' ? order : 'asc'}
            onClick={() => sortData('expiry')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'expiry'}
                hover={state.hoverTabelSortLabel}
                propertyName={1}
                direction={orderBy === 'expiry' ? order : 'asc'}
              />
            )}
          >
            Expiry
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '20px',
          }}
          className="sticky"
          align="left"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 2 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'strike'}
            direction={orderBy === 'strike' ? order : 'asc'}
            onClick={() => sortData('strike')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'strike'}
                hover={state.hoverTabelSortLabel}
                propertyName={2}
                direction={orderBy === 'strike' ? order : 'asc'}
              />
            )}
          >
            Strike
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '20px',
          }}
          className="sticky"
          align="left"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 3 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'put_call'}
            direction={orderBy === 'put_call' ? order : 'asc'}
            onClick={() => sortData('put_call')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'put_call'}
                hover={state.hoverTabelSortLabel}
                propertyName={3}
                direction={orderBy === 'put_call' ? order : 'asc'}
              />
            )}
          >
            P/C
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '32px',
          }}
          className="sticky"
          align="left"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 4 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'theo_bid'}
            direction={orderBy === 'theo_bid' ? order : 'asc'}
            onClick={() => sortData('theo_bid')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'theo_bid'}
                hover={state.hoverTabelSortLabel}
                propertyName={4}
                direction={orderBy === 'theo_bid' ? order : 'asc'}
              />
            )}
          >
            Bid
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '32px',
          }}
          className="sticky"
          align="left"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 5 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'theo_ask'}
            direction={orderBy === 'theo_ask' ? order : 'asc'}
            onClick={() => sortData('theo_ask')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'theo_ask'}
                hover={state.hoverTabelSortLabel}
                propertyName={5}
                direction={orderBy === 'theo_ask' ? order : 'asc'}
              />
            )}
          >
            Ask
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.modalTableHeaderCell, padding: 0 }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 6 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'volValue'}
            direction={orderBy === 'volValue' ? order : 'asc'}
            onClick={() => sortData('volValue')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'volValue'}
                hover={state.hoverTabelSortLabel}
                propertyName={6}
                direction={orderBy === 'volValue' ? order : 'asc'}
              />
            )}
          >
            Vol/OI
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.modalTableHeaderCell, padding: 0 }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 7 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'volume'}
            direction={orderBy === 'volume' ? order : 'asc'}
            onClick={() => sortData('volume')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'volume'}
                hover={state.hoverTabelSortLabel}
                propertyName={7}
                direction={orderBy === 'volume' ? order : 'asc'}
              />
            )}
          >
            Volume
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '32px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 8 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'open_int'}
            direction={orderBy === 'open_int' ? order : 'asc'}
            onClick={() => sortData('open_int')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'open_int'}
                hover={state.hoverTabelSortLabel}
                propertyName={8}
                direction={orderBy === 'open_int' ? order : 'asc'}
              />
            )}
          >
            OI
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '32px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 9 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'ivol'}
            direction={orderBy === 'ivol' ? order : 'asc'}
            onClick={() => sortData('ivol')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'ivol'}
                hover={state.hoverTabelSortLabel}
                propertyName={9}
                direction={orderBy === 'ivol' ? order : 'asc'}
              />
            )}
          >
            IV%
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.modalTableHeaderCell, padding: 0 }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 10 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'ivol_chg'}
            direction={orderBy === 'ivol_chg' ? order : 'asc'}
            onClick={() => sortData('ivol_chg')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'ivol_chg'}
                hover={state.hoverTabelSortLabel}
                propertyName={10}
                direction={orderBy === 'ivol_chg' ? order : 'asc'}
              />
            )}
          >
            Chg
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            padding: 0,
            width: '40px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 11 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'itm_prob'}
            direction={orderBy === 'itm_prob' ? order : 'asc'}
            onClick={() => sortData('itm_prob')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'itm_prob'}
                hover={state.hoverTabelSortLabel}
                propertyName={11}
                direction={orderBy === 'itm_prob' ? order : 'asc'}
              />
            )}
          >
            ITM
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{ ...styles.modalTableHeaderCell, padding: 0 }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            onMouseOver={() => {
              setState({ hoverTabelSortLabel: 12 });
            }}
            onMouseOut={() => {
              setState({ hoverTabelSortLabel: '' });
            }}
            style={{ color: 'white' }}
            active={orderBy === 'RRS'}
            direction={orderBy === 'RRS' ? order : 'asc'}
            onClick={() => sortData('RRS')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'RRS'}
                hover={state.hoverTabelSortLabel}
                propertyName={12}
                direction={orderBy === 'RRS' ? order : 'asc'}
              />
            )}
          >
            RR$
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default ModalHeadingRow;



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/components/ModalHeadingRow.jsx